@if (tree) {
  <div>
    <ul #treeCmp
      class="tree-container tree-level-1 p-0">
      <ng-container *ngTemplateOutlet="recursiveMenu; context: {tree: tree, i:1}"></ng-container>
    </ul>
    <ng-template #recursiveMenu let-tree="tree" let-i="i+1">
      @for (node of tree.treeItems; track node; let subindex = $index; let isFirst = $first) {
        <li
          [attr.aria-setsize]="tree.treeItems.length"
          [class]="node.data.class"
          >
          @switch (node.linkType) {
            @case ('INNER_LINK') {
              <a [id]="'side_nav_node_' + node.nodeId"
                [attr.aria-expanded]="node.isExpanded"
                [class.active-node]="activeNode  == node"
                routerLinkActive="active-node"
                [class.has-children]="node.tree && i <= depth"
                class="btn link p-0"
                [routerLink]="node.href"
                [queryParams]="node.queryParams"
                [fragment]="node.fragment"
                >
                @if (node.tree && i <= depth) {
                  <i class="fa" [ngClass]="{'fa-angle-down' : node.isExpanded, 'fa-angle-left' : !node.isExpanded}"
                    (click)="node.handleClick($event)"
                    (keydown)="node.handleKeydown($event)"
                  (keypress)="node.handleKeypress($event)"></i>
                }
                @if (node.data.icon) {
                  <i [class]="node.data.icon"></i>
                }
                <span>{{node.data.name}}</span>
              </a>
            }
            @case ('EXTERNAL_LINK') {
              <a [id]="'side_nav_node_' + node.nodeId"
                class="btn external-link p-0"
                [class.active-node]="activeNode == node"
                routerLinkActive="active-node"
                [href]="node.href">
                @if (node.tree && i <= depth) {
                  <i class="fa" [ngClass]="{'fa-angle-down' : node.isExpanded, 'fa-angle-left' : !node.isExpanded}"
                    (click)="node.handleClick($event)"
                    (keydown)="node.handleKeydown($event)"
                  (keypress)="node.handleKeypress($event)"></i>
                }
                @if (node.data.icon) {
                  <i [class]="node.data.icon"></i>
                }
                <span>{{node.data.name}}</span>
              </a>
            }
            @default {
              <button [id]="'side_nav_node_' + node.nodeId"
                [class.active-node]="activeNode  == node"
                (keydown)="node.handleKeydown($event)"
                (keypress)="node.handleKeypress($event)"
                (click)="nodeClick(node,$event)"
                [attr.aria-expanded]="node.isExpanded"
                [ngClass]="{'d-none' : node.data.line_preview_name == 'node-pdf'}"
                class="button btn p-0"
                >
                @if (node.tree && i <= depth ) {
                  <i class="fa" [ngClass]="{'fa-angle-down' : node.isExpanded, 'fa-angle-left' : !node.isExpanded}"></i>
                }
                @if (node.data.icon && i <= depth) {
                  <i [class]="node.data.icon"></i>
                }
                <span>{{node.data.name}}</span>
              </button>
            }
          }
          @if (node.isExpanded && node.tree && i <= depth) {
            <ul
              [attr.aria-expanded]="node.isExpanded"
              class="tree-container tree-level-{{i}}">
              <ng-container *ngTemplateOutlet="recursiveMenu; context: {tree: node.tree, i: i}"></ng-container>
            </ul>
          }
        </li>
      }
    </ng-template>
  </div>
}

